import gql from 'graphql-tag';
import { PostFragments } from '@getaccept/dsr-shared-new/src/api/posts/graphql/post.fragments';

export class PostQueries {
  static load = gql`
    query getPosts($limit: Float, $offset: Float, $sortOrder: SortOrder, $sortBy: PostSortBy) {
      getPosts(limit: $limit, offset: $offset, sortOrder: $sortOrder, sortBy: $sortBy) {
        ...postFragment
      }
    }
    ${PostFragments.post}
  `;
}
